import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { WhatsAppFloat } from "@/components/common/WhatsAppFloat";
import { CallFloat } from "@/components/common/CallFloat";
import { CookieBanner } from "@/components/common/CookieBanner";
import { ChatBot } from "@/components/common/ChatBot";
import { SchemaLocalBusiness } from "@/components/common/SchemaLocalBusiness";

export const Layout = () => {
  const location = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <SchemaLocalBusiness />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloat />
      <CallFloat />
      <ChatBot />
      <CookieBanner />
    </div>
  );
};
